import { theme } from "../../theme.js";

export default function SocialButton({ provider = "google", onClick }) {
  const isApple = provider === "apple";
  const isGoogle = provider === "google";
  const label = isApple ? "Continue with Apple" : isGoogle ? "Continue with Google" : "Continue";

  return (
    <button onClick={onClick} style={{...styles(theme).btn, ...(isApple ? styles(theme).apple : styles(theme).google)}}>
      <span style={styles(theme).icon}>{isApple ? "" : "G"}</span>
      <span>{label}</span>
    </button>
  );
}

const styles = (theme) => ({
  btn: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.md,
    width: "100%",
    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
    borderRadius: theme.radius.lg,
    border: `1px solid ${theme.colors.border}`,
    background: theme.colors.white,
    color: theme.colors.textInverted,
    cursor: "pointer",
    fontWeight: theme.fonts.weight.semibold,
    justifyContent: "center",
  },
  google: {
    borderColor: theme.colors.border,
  },
  apple: {
    background: "#000",
    color: theme.colors.white,
    borderColor: "#000",
  },
  icon: {
    width: 22,
    height: 22,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: theme.radius.sm,
    fontSize: 16,
  },
});
